import { render, staticRenderFns } from "./createMoney.vue?vue&type=template&id=21ba546d&scoped=true&"
import script from "./createMoney.vue?vue&type=script&lang=js&"
export * from "./createMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba546d",
  null
  
)

export default component.exports